import { TIMEFRAME_24HRS, TimeframeWithLocalTimes } from '@ftr/contracts/api/shared'
import { AssetStatus, Playability, RecordingSegment, RecordingWithSegments } from '@ftr/contracts/read'
import { RecordingConversionStatus, RecordingType } from '@ftr/contracts/type/recording'
import { Timecode, Uuid, generateUuid } from '@ftr/contracts/type/shared'
import { AbstractBuilder } from '@ftr/foundation'
import { LocalDate, LocalDateTime, LocalTime, ZoneId } from '@js-joda/core'
import { CourtroomBuilder } from './CourtroomBuilder'
import { RecordingSegmentBuilder } from './RecordingSegmentBuilder'

export class RecordingWithSegmentsBuilder extends AbstractBuilder<RecordingWithSegments> {
  constructor(
    assetStatus: AssetStatus = AssetStatus.Missing,
    recordingId: Uuid = generateUuid(),
    zoneId: ZoneId | undefined = undefined,
  ) {
    const courtSystemId = generateUuid()
    super(
      new RecordingWithSegments(
        recordingId,
        courtSystemId,
        `recording-${recordingId}`,
        LocalDate.parse('2020-01-01'),
        assetStatus === AssetStatus.Exists
          ? RecordingConversionStatus.Converted
          : RecordingConversionStatus.Unconverted,
        new CourtroomBuilder().with({ courtSystemId }).build(),
        createSegments(recordingId, RecordingType.TRM, [assetStatus, assetStatus], zoneId),
        [],
        generateUuid(),
        false,
        false,
        undefined,
        RecordingType.TRM,
        false,
        false,
        1,
        [TIMEFRAME_24HRS],
        [new TimeframeWithLocalTimes(LocalTime.MIN, LocalTime.MAX)],
        undefined,
        [],
        false,
        new Set(),
      ),
    )
  }

  realtime(): this {
    return this.with({ recordingType: RecordingType.Stream })
  }

  withSegments(assetStatuses: AssetStatus[]): this {
    return this.with({ segments: createSegments(this.result.id, RecordingType.TRM, assetStatuses) })
  }

  withStreamSegments(): this {
    Object.assign(this.result, {
      segments: createSegments(this.result.id, RecordingType.Stream, [AssetStatus.Exists, AssetStatus.Exists]),
    })
    return this
  }

  withVideo(): this {
    const tags = this.result.tags ?? new Set()
    return this.with({ tags: tags.add('video'), hasVideo: true })
  }
}

export function createSegments(
  recordingId: Uuid,
  recordingType: RecordingType,
  assetStatuses: AssetStatus[],
  zoneId: ZoneId | undefined = undefined,
): RecordingSegment[] {
  return assetStatuses.map((assetStatus, idx) =>
    new RecordingSegmentBuilder()
      .with({
        recordingId,
        recordingType,
        playability: assetStatus === AssetStatus.Exists ? Playability.Playable : Playability.NotPlayable,
        assetStatus,
        timecode: new Timecode(LocalDateTime.parse('2019-01-01T09:00').plusMinutes(idx * 5), 300000),
        zoneId,
      })
      .build(),
  )
}
